export const BLOCKED_STATES = {
  tier1: {
    label: "Prohibited",
    blockLevel: "FULL",
    states: {
      CA: { name: "California", reason: "State prohibition — sweepstakes restricted" },
      CT: { name: "Connecticut", reason: "State prohibition — sweepstakes restricted" },
      DE: { name: "Delaware", reason: "State prohibition — regulated market" },
      ID: { name: "Idaho", reason: "State prohibition — sweepstakes restricted" },
      MI: { name: "Michigan", reason: "State prohibition — regulated market" },
      MT: { name: "Montana", reason: "State prohibition — sweepstakes restricted" },
      NJ: { name: "New Jersey", reason: "State prohibition — regulated market" },
      NV: { name: "Nevada", reason: "State prohibition — regulated market" },
      NY: { name: "New York", reason: "State prohibition — sweepstakes restricted" },
      TN: { name: "Tennessee", reason: "State prohibition — sweepstakes restricted" },
      WA: { name: "Washington", reason: "State prohibition — sweepstakes restricted" },
    },
  },
  tier2: {
    label: "Restricted (SC Blocked)",
    blockLevel: "SC_ONLY",
    states: {
      FL: { name: "Florida", reason: "Limited participation — GC only, no SC redemption" },
      IN: { name: "Indiana", reason: "Limited participation — GC only, no SC redemption" },
      KY: { name: "Kentucky", reason: "Limited participation — GC only, no SC redemption" },
      LA: { name: "Louisiana", reason: "Limited participation — GC only, no SC redemption" },
      MD: { name: "Maryland", reason: "Limited participation — GC only, no SC redemption" },
      MS: { name: "Mississippi", reason: "Limited participation — GC only, no SC redemption" },
      PA: { name: "Pennsylvania", reason: "Limited participation — GC only, no SC redemption" },
      WV: { name: "West Virginia", reason: "Limited participation — GC only, no SC redemption" },
    },
  },
  tier3: {
    label: "Precautionary Restriction",
    blockLevel: "SC_ONLY",
    states: {},
  },
  tier4: {
    label: "Monitor Weekly",
    blockLevel: "MONITOR",
    states: {},
  },
};

export const FULL_BLOCK_STATES = [
  ...Object.keys(BLOCKED_STATES.tier1.states),
];

export const SC_BLOCK_STATES = [
  ...Object.keys(BLOCKED_STATES.tier2.states),
  ...Object.keys(BLOCKED_STATES.tier3.states),
];
export const ALL_BLOCKED_STATE_CODES = [...FULL_BLOCK_STATES, ...SC_BLOCK_STATES];
export const MONITOR_STATE_CODES = Object.keys(BLOCKED_STATES.tier4.states);

export const getStateTier = (stateCode) => {
  const code = String(stateCode || "").toUpperCase();
  if (BLOCKED_STATES.tier1.states[code]) return 1;
  if (BLOCKED_STATES.tier2.states[code]) return 2;
  if (BLOCKED_STATES.tier3.states[code]) return 3;
  if (BLOCKED_STATES.tier4.states[code]) return 4;
  return null;
};

export const isFullyBlocked = (stateCode) => FULL_BLOCK_STATES.includes(String(stateCode || "").toUpperCase());
export const isSCBlocked = (stateCode) => ALL_BLOCKED_STATE_CODES.includes(String(stateCode || "").toUpperCase());

export const getBlockReason = (stateCode) => {
  const code = String(stateCode || "").toUpperCase();
  const t1 = BLOCKED_STATES.tier1.states[code];
  const t2 = BLOCKED_STATES.tier2.states[code];
  const t3 = BLOCKED_STATES.tier3.states[code];
  if (t1) return t1.reason;
  if (t2) return t2.reason;
  if (t3) return t3.reason;
  return null;
};
